export default "__VITE_ASSET__BSFc$6rU__"